import { useEffect, useState } from 'react';
import ToggleRow from '../common/ToggleRow';

// The "always run on a card change" switch of an automation rule (keepr-api
// KPR-706, `alwaysRunOnCardChange`): a card change runs this rule on the items
// it brings onto the card even when the person leaves it unticked. It applies
// only to a rule on items that runs when one is added (no events ticked is
// every event); an edit that takes Created away clears a stored one.

// The switch's state, set from the rule each time the editor opens.
export function useAlwaysRun( rule, open ) {
	const [ on, setOn ] = useState( false );
	useEffect( () => { if ( open ) setOn( rule?.alwaysRunOnCardChange === true ); }, [ open, rule ] );
	return [ on, setOn ];
}

export function alwaysRunApplies( watchesEntries, events ) {
	return ! watchesEntries && ( ! events.length || events.includes( 'created' ) );
}

// What a save sends: true when on, and false only to clear a stored one.
export function alwaysRunPayload( applies, on, rule ) {
	if ( applies && on ) return { alwaysRunOnCardChange: true };
	return rule?.alwaysRunOnCardChange === true ? { alwaysRunOnCardChange: false } : {};
}

export default function AlwaysRunToggle( { checked, onChange } ) {
	return (
		<ToggleRow
			label='Always run on a card change'
			description={'When someone changes items to this card, this rule runs on them even if they leave it unticked. '
				+ 'Turn it on for a rule that keeps other records right, such as a count or a stock.'}
			checked={checked}
			onChange={onChange}
		/>
	);
}
